module.exports = __webpack_public_path__ + "static/img/hutomagnes_vilkek.2d69d3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/nyomtatott-hutomagnes/hutomagnes_vilkek.jpg
// module id = 569
// module chunks = 0